import React, { useEffect } from 'react';
import { Container, Grow, Grid, Paper } from '@material-ui/core';

import EventsPagination from './EventsPagination';
import { Events } from "./Events";
import { CulturalCalendar } from './CulturalCalendar';
import { UpcomingSignalsPanel } from './UpcomingSignalsPanel';
import { useDispatch } from 'react-redux';

import { useLocation } from 'react-router-dom';

import { getEvents } from '../../actions/events';
import {
    getCuratedEventsForTheme,
    getDiscoveryTheme,
    readDiscoveryTheme,
} from '../../lib/discoveryThemes';
import { ThemeSwitch } from '../Theme/ThemeSwitch';

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export const EventsPage = (props) => {
    const location = useLocation();
    const query = useQuery();
    const page = query.get('page') || 1;
    const activeTheme = readDiscoveryTheme(location.search);
    const themeConfig = getDiscoveryTheme(activeTheme);
    const curatedEvents = getCuratedEventsForTheme(activeTheme);

    const dispatch = useDispatch();

    // Only run once, paginatino page will take over once vars are populated
    useEffect(() => {
        dispatch(getEvents(page));
    }, [page, dispatch]);

    return (
        <Grow in>
            <Container className="atlas-route-shell">
                <div className="atlas-page-header">
                    <span className="atlas-eyebrow">{themeConfig.events.eyebrow}</span>
                    <h1>{themeConfig.events.title}</h1>
                    <p>{themeConfig.events.description}</p>
                </div>

                <ThemeSwitch className="atlas-theme-switch--page" overrides={{ page: 1 }} />

                <div className="atlas-section atlas-section--tight">
                    <UpcomingSignalsPanel lat={props.lat} lng={props.lng} theme={activeTheme} />
                </div>

                {activeTheme === 'cultural' ? (
                    <>
                        <div className="atlas-section atlas-section--tight">
                            <CulturalCalendar lat={props.lat} lng={props.lng} />
                        </div>
                        <div className="atlas-section atlas-section--tight">
                            <Paper elevation={6} className="atlas-sidebar-card atlas-theme-story-card">
                                <div className="atlas-sidebar-copy atlas-sidebar-copy--flush">
                                    <h3>Seasonal and ceremonial context</h3>
                                    <p>
                                        Keep these broader tradition notes beside the dated calendar so
                                        public observances and longer seasonal practices can be read together.
                                    </p>
                                </div>
                                <div className="atlas-catalog-grid">
                                    {curatedEvents.map((item) => (
                                        <article key={item.id} className="atlas-catalog-card">
                                            <span className="atlas-card-kicker">{item.category_label}</span>
                                            <h3>{item.title}</h3>
                                            <p>{item.summary}</p>
                                            <div className="atlas-detail-list">
                                                <span>
                                                    <strong>Timing</strong>
                                                    {item.starts_at}
                                                </span>
                                                <span>
                                                    <strong>Why it matters</strong>
                                                    {item.why_it_matters.join(', ')}
                                                </span>
                                            </div>
                                        </article>
                                    ))}
                                </div>
                            </Paper>
                        </div>
                    </>
                ) : null}

                <Grid container justifyContent="space-between" alignItems="stretch" spacing={3}>
                    <Grid item xs={12} md={8}>
                        <Events theme={activeTheme} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={6} className="atlas-sidebar-card">
                            <div className="atlas-sidebar-copy">
                                <h3>{themeConfig.events.sidebarTitle}</h3>
                                <p>{themeConfig.events.sidebarCopy}</p>
                            </div>
                            {activeTheme === 'cultural' ? (
                                <div className="atlas-detail-note">
                                    Some entries mark a specific public date, while others describe a
                                    broader seasonal window. Use the calendar for dated observances and
                                    the tradition cards for longer context.
                                </div>
                            ) : null}
                            <EventsPagination page={page} />
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Grow>
    )
}
